// eslint-disable-next-line
import { Tab } from "@headlessui/react";
// eslint-disable-next-line
import CommentListing from "components/CommentListing/CommentListing";
import React, { FC, useEffect, useState } from "react";
import Avatar from "shared/Avatar/Avatar";
import ButtonSecondary from "shared/Button/ButtonSecondary";
// eslint-disable-next-line
import SocialsList from "shared/SocialsList/SocialsList";
import { Helmet } from "react-helmet";
import { useParams } from "react-router";
import axios from "axios";
import { IUser, ManyItem } from "types/interfaces";
import moment from "moment";
import ItemCard from "components/ItemCard/ItemCard";
import GoogleMapReact from "google-map-react";
import LocationMarker from "components/AnyReactComponent/LocationMarker";
import { RentripsURL } from "utils/request";

export interface AuthorPageProps {
  className?: string;
}

const DEMO_DATA: IUser = {
  _id: "1",
  fullName: "Full Name",
  description: "description",
  avatar: "/avatar.png",
  createdAt: Date.now(),
  verified: false,
  address: {
    kabupaten: { name: "Kabupaten Bogor" },
    kecamatan: { name: "Kecamatan Cibinong" },
  },
  products: [],
};

const AuthorPage: FC<AuthorPageProps> = ({ className = "" }) => {
  const { id } = useParams<{ id: string }>();
  const [userProfile, setUserProfile] = useState<IUser>(DEMO_DATA);
  const getUserData = async (id: string) => {
    const { data } = await axios.get(RentripsURL + `/api/user/profile/${id}`);
    setUserProfile(data);
  };

  useEffect(() => {
    getUserData(id);
  }, []);

  // let [categories] = useState(["Stays", "Experiences", "Car for rent"]);

  const renderSidebar = () => {
    return (
      <div className=" w-full flex flex-col items-center text-center sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-7 px-0 sm:p-6 xl:p-8">
        <Avatar
          hasChecked={userProfile.verified}
          hasCheckedClass="w-6 h-6 -top-0.5 right-2"
          sizeClass="w-28 h-28"
          imgUrl={userProfile.avatar}
        />

        {/* ---- */}
        <div className="space-y-3 text-center flex flex-col items-center">
          <h2 className="text-3xl font-semibold">{userProfile.fullName}</h2>
          {/* <StartRating className="!text-base" /> */}
        </div>

        {/* ---- */}
        <p className="text-neutral-500 dark:text-neutral-400">
          {userProfile.description}
        </p>

        {/* SOCIAL LIST */}
        {/* <SocialsList
          className="!space-x-3"
          itemClass="flex items-center justify-center w-9 h-9 rounded-full bg-neutral-100 dark:bg-neutral-800 text-xl"
        /> */}

        {/* ---- */}
        <div className="border-b border-neutral-200 dark:border-neutral-700 w-14"></div>

        {/* ---- */}
        <div className="space-y-4">
          {userProfile.address?._id && (
            <div className="flex items-center space-x-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-neutral-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />
              </svg>
              <span className="text-neutral-6000 dark:text-neutral-300">
                Tinggal di{" "}
                {userProfile.address?.kabupaten?.name
                  ? userProfile.address?.kabupaten?.name
                  : "Indonesia"}
              </span>
            </div>
          )}

          {/* <div className="flex items-center space-x-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-neutral-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
              />
            </svg>
            <span className="text-neutral-6000 dark:text-neutral-300">
              Berbahasa Indonesia
            </span>
          </div> */}

          <div className="flex items-center space-x-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-neutral-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span className="text-neutral-6000 dark:text-neutral-300">
              Bergabung Sejak {moment(userProfile.createdAt).format("ll")}
            </span>
          </div>
        </div>
        {userProfile.address?._id && (
          <a
            className="ttnc-ButtonPrimary disabled:bg-opacity-70 bg-primary-6000 dark:bg-primary-6000  hover:bg-primary-700 text-neutral-50 nc-Button relative h-auto inline-flex items-center justify-center rounded-full transition-colors dark:text-neutral-200 px-4 py-3 sm:px-6 text-sm sm:text-base font-medium"
            href={`https://www.google.com/maps/search/?api=1&query=${
              userProfile.address?.map?.latitude || ""
            },${userProfile.address?.map?.longitude || ""}`}
            target="_blank"
            rel="noreferrer"
          >
            Lihat di Peta
          </a>
        )}

        {/* {renderMaps()} */}
      </div>
    );
  };
  // eslint-disable-next-line
  const renderMaps = () => {
    return (
      <>
        {" "}
        {userProfile.address?._id && (
          <div className="w-full h-52 rounded-md overflow-hidden">
            <GoogleMapReact
              bootstrapURLKeys={{
                key: "AIzaSyDxJaU8bLdx7sSJ8fcRdhYS1pLk8Jdvnx0",
              }}
              // onClick={() => {
              //   // New tab to google maps
              //   window.open(
              //     `https://www.google.com/maps/search/?api=1&query=${
              //       userProfile.address?.map?.latitude || ""
              //     },${userProfile.address?.map?.longitude || ""}`
              //   );
              // }}
              defaultZoom={15}
              yesIWantToUseGoogleMapApiInternals
              defaultCenter={{
                lat: -8.746325945216654,
                lng: 115.16803037857355,
              }}
              center={{
                lat: userProfile.address?.map?.latitude || 0,
                lng: userProfile.address?.map?.longitude || 0,
              }}
            >
              <LocationMarker
                lat={userProfile.address?.map?.latitude || 0}
                lng={userProfile.address?.map?.longitude || 0}
              />
            </GoogleMapReact>
          </div>
        )}
      </>
    );
  };

  const renderSection1 = () => {
    return (
      <div className="listingSection__wrap">
        <div>
          <h2 className="text-2xl font-semibold truncate">
            Listing dari {userProfile.fullName}
          </h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Beberapa barang yang menjadi andalan {userProfile.fullName}
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

        <div>
          {/* <Tab.Group>
            <Tab.List className="flex space-x-1 overflow-x-auto">
              {categories.map((item) => (
                <Tab key={item} as={Fragment}>
                  {({ selected }) => (
                    <button
                      className={`flex-shrink-0 block !leading-none font-medium px-5 py-2.5 text-sm sm:text-base sm:px-6 sm:py-3 capitalize rounded-full focus:outline-none ${
                        selected
                          ? "bg-secondary-900 text-secondary-50 "
                          : "text-neutral-500 dark:text-neutral-400 dark:hover:text-neutral-100 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                      } `}
                    >
                      {item}
                    </button>
                  )}
                </Tab>
              ))}
            </Tab.List>
            <Tab.Panels>
              <Tab.Panel className="">
                <div className="mt-8 grid grid-cols-1 gap-6 md:gap-7 sm:grid-cols-2">
                  {DEMO_STAY_LISTINGS.filter((_, i) => i < 4).map((stay) => (
                    <StayCard key={stay.id} data={stay} />
                  ))}
                </div>
                <div className="flex mt-11 justify-center items-center">
                  <ButtonSecondary>Show me more</ButtonSecondary>
                </div>
              </Tab.Panel>
              <Tab.Panel className="">
                <div className="mt-8 grid grid-cols-1 gap-6 md:gap-7 sm:grid-cols-2">
                  {DEMO_EXPERIENCES_LISTINGS.filter((_, i) => i < 4).map(
                    (stay) => (
                      <ExperiencesCard key={stay.id} data={stay} />
                    )
                  )}
                </div>
                <div className="flex mt-11 justify-center items-center">
                  <ButtonSecondary>Show me more</ButtonSecondary>
                </div>
              </Tab.Panel>
              <Tab.Panel className=""></Tab.Panel>
            </Tab.Panels>
          </Tab.Group> */}
          <div className="mt-8 grid grid-cols-1 gap-6 md:gap-7 sm:grid-cols-2">
            {userProfile.products.length > 0 ? (
              userProfile.products.map((item: ManyItem, index: number) => (
                <ItemCard key={index} data={item} />
              ))
            ) : (
              <span className="text-sm font-thin">
                {userProfile.fullName} tidak memiliki barang apapun
              </span>
            )}
          </div>
          <div className="flex mt-11 justify-center items-center">
            {userProfile.products.length > 16 && (
              <ButtonSecondary>Show me more</ButtonSecondary>
            )}
          </div>
        </div>
      </div>
    );
  };

  // KOMEN ORANG
  // const renderSection2 = () => {
  //   return (
  //     <div className="listingSection__wrap">
  //       {/* HEADING */}
  //       <h2 className="text-2xl font-semibold">Reviews (23 reviews)</h2>
  //       <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

  //       {/* comment */}
  //       <div className="divide-y divide-neutral-100 dark:divide-neutral-800">
  //         <CommentListing hasListingTitle className="pb-8" />
  //         <CommentListing hasListingTitle className="py-8" />
  //         <CommentListing hasListingTitle className="py-8" />
  //         <CommentListing hasListingTitle className="py-8" />
  //         <div className="pt-8">
  //           <ButtonSecondary>View more 20 reviews</ButtonSecondary>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  return (
    <div className={`nc-AuthorPage ${className}`} data-nc-id="AuthorPage">
      <Helmet>
        <title>Vendor {userProfile.fullName} | Rentrips.id</title>
        <meta
          name="description"
          content={`Sewa barang ${userProfile.fullName} sekarang, barang sewa dengan kualitas terbaik dan harga terjangkau. Dapatkan berbagai promo menarik. Sewa barang, ya Rentrips.id aja`}
        />
      </Helmet>
      <main className="container mt-12 mb-24 lg:mb-32 flex flex-col lg:flex-row">
        <div className="block flex-grow mb-24 lg:mb-0">
          <div className="lg:sticky lg:top-24">{renderSidebar()}</div>
        </div>
        <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pl-10 flex-shrink-0">
          {renderSection1()}
          {/* {renderSection2()} */}
        </div>
      </main>
    </div>
  );
};

export default AuthorPage;
